import React from 'react';
import './ArchitecturalServices.css';
import useScrollToTop from './useScrollToTop';
import ReusableLanding from './ReusableLanding';
import image2 from '../img/kitchen_modern_classic.png';
import { FaHome, FaBuilding, FaStore, FaLandmark, FaPaintRoller, FaPlusSquare, FaTools, FaLightbulb, FaCheckCircle, FaPencilRuler, FaTrashAlt, FaHandsHelping, FaSearch, FaEye } from 'react-icons/fa'; // Import relevant icons
import { Link } from 'react-router-dom';

const Renovations = () => {
    useScrollToTop();
    return (
        <>
            <ReusableLanding
                imageUrl={image2}
                title="Renovations"
                description="Transform your existing spaces with our comprehensive renovation services. At Housekaar, we breathe new life into homes and commercial properties, enhancing their functionality and aesthetics."
            />
            <div className="architectural-services-page">
                <section className="services-overview">
                    <h2>Our Renovation Services</h2>
                    <p>We offer a wide range of renovation services to revitalize your residential and commercial spaces.</p>
                    <ul className="services-list">
                        <li><FaHome className="service-icon" /> <strong>Home Renovations:</strong> Updating and remodeling kitchens, bathrooms, living rooms, bedrooms, and entire homes to meet your evolving needs and style.</li>
                        <li><FaBuilding className="service-icon" /> <strong>Office Renovations:</strong> Modernizing office layouts, improving functionality, and creating inspiring workspaces that enhance productivity and employee well-being.</li>
                        <li><FaStore className="service-icon" /> <strong>Retail Renovations:</strong> Enhancing retail environments with updated designs, improved layouts, and appealing aesthetics to create a better customer experience and drive sales.</li>
                        <li><FaLandmark className="service-icon" /> <strong>Historical Renovations:</strong> Preserving the architectural integrity and historical significance of older buildings while updating them for modern use and safety standards.</li>
                        <li><FaPaintRoller className="service-icon" /> <strong>Exterior Renovations:</strong> Updating building facades, roofing, siding, windows, doors, and landscaping to improve curb appeal and protect the property's structure.</li>
                    </ul>
                </section>

                <section className="benefits-section">
                    <h2>Benefits of Our Renovations</h2>
                    <ul className="benefits-list">
                        <li className="card">
                            <div className="benefit-icon"><FaPlusSquare /></div>
                            <h3>Increased Property Value</h3>
                            <p>Enhancing the market value and appeal of your property through strategic and well-executed renovations.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaTools /></div>
                            <h3>Improved Functionality</h3>
                            <p>Optimizing existing spaces for better usability, flow, and efficiency to meet your specific lifestyle or business requirements.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaLightbulb /></div>
                            <h3>Modernization</h3>
                            <p>Updating outdated spaces with contemporary designs, modern materials, and energy-efficient solutions.</p>
                        </li>
                        <li className="card">
                            <div className="benefit-icon"><FaCheckCircle /></div>
                            <h3>Personalization</h3>
                            <p>Tailoring every aspect of the renovation to reflect your unique tastes, needs, and preferences, creating a space that truly feels like your own.</p>
                        </li>
                    </ul>
                </section>

                <section className="process-section">
                    <h2>Our Process</h2>
                    <p>We follow a systematic and collaborative process to ensure your renovation project is a success.</p>
                    <ol className="process-list">
                        <li><FaSearch className="process-icon" /> <strong>Initial Assessment:</strong> Conducting a thorough evaluation of the existing space, listening to your goals, and discussing your vision and budget for the renovation.</li>
                        <li><FaPencilRuler className="process-icon" /> <strong>Design and Planning:</strong> Developing detailed renovation plans, including layouts, material selections, and timelines, often involving 3D visualizations to help you see the final result.</li>
                        <li><FaTrashAlt className="process-icon" /> <strong>Demolition and Preparation:</strong> Carefully and safely preparing the space for renovation, including demolition of existing structures and ensuring a clean and organized work area.</li>
                        <li><FaHandsHelping className="process-icon" /> <strong>Construction and Installation:</strong> Executing the renovation work with our team of skilled professionals, ensuring quality craftsmanship and adherence to the planned design.</li>
                        <li><FaEye className="process-icon" /> <strong>Final Inspection:</strong> Conducting a comprehensive final walkthrough with you to review the completed renovation, address any final details, and ensure your complete satisfaction.</li>
                    </ol>
                </section>

                <section className="get-started-cta">
                    <h2>Let's Reimagine Your Space</h2>
                    <p>
                        Contact us today to schedule your initial consultation and discuss your renovation project. Let us help you transform your current space into something you'll love for years to come.
                    </p>
                    <Link to="/pricing">
                        <button className="custom-button">Contact Us</button>
                    </Link>
                </section>
            </div>
        </>
    );
};

export default Renovations;